export default "__VITE_ASSET__BFBs809S__"